<div class="upload-files-container"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave($event)"
     (drop)="onDrop($event)"
     (click)="fileUpload.click()">
    <div class="upload-files-placeholder">
        <div *ngIf="files.length == 0" class="upload-files-placeholder-icon">
            <app-icon [icon]="Icons.uploadFiles"></app-icon>
        </div>
        <div class="upload-files-placeholder-text">
             {{ getLabel() }}
        </div>
    </div>
</div>
<input type="file" style="display:none" multiple #fileUpload (change)="onFilesSelected($event)"/>
